// extracted by css-extract-rspack-plugin
export default {"header":"_c6197e9","isOpen":"_1fea36d8","title":"_e4bb2ef6","titleMultiline":"_bb7a4791","button":"_32e283a0","makeOfferButton":"_b3fc611a"};